import MDButton from "components/MDButton";
import { useCallback } from "react";
import useSubscriptionUrl from "hooks/subscriptions/useSubscriptionUrl";

export default function AiMappingUpgradeButton({
  label = "Upgrade to AI mapping",
  fullWidth = false,
}: {
  label?: string;
  fullWidth?: boolean;
}) {
  const { label: subscriptionLabel, figureOutUrl, loading, error } = useSubscriptionUrl();

  const onClick = useCallback(async () => {
    const url = await figureOutUrl();
    if (url) {
      window.open(url, "_blank");
    }
  }, [figureOutUrl]);

  return (
    <MDButton
      color="info"
      variant="gradient"
      size="small"
      fullWidth={fullWidth}
      onClick={onClick}
      disabled={loading || !!error}
      data-testid="ai-mapping-upgrade-button"
    >
      {loading ? "Loading…" : label || subscriptionLabel}
    </MDButton>
  );
}
